const SDK_VERSION = '8.29.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
